import React from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/router/routes';

export const ProfileScreen = () => {
  return (
    <div>
      ProfileScreen
      <div>
        <Link to={routes.profile_edit}>Editar perfil</Link>
      </div>
    </div>
  );
};
